function canExpandLeft(column) {
    return column > 0;
}

function canExpandRight(column, columnSpan, columnLimit) {
    return column + 1 + (columnSpan - 1) < columnLimit;
}

function canExpandBottom(row, rowSpan, rowLimit) {
    return row + 1 + (rowSpan - 1) < rowLimit;
}

function canExpandTop(row) {
    return row > 0;
}

function canCollapseLeft(columnSpan) {
    return columnSpan > 1;
}

function canCollapseRight(columnSpan) {
    return columnSpan > 1;
}

function canCollapseTop(rowSpan) {
    return rowSpan > 1;
}

function canCollapseBottom(rowSpan) {
    return rowSpan > 1;
}

function createGridAreaDefinition(row, column, rowSpan = 1, columnSpan = 1) {
    return `${row + 1} / ${column + 1} / ${row + 1 + rowSpan} / ${column + 1 + columnSpan}`;
}

export {
    canExpandLeft,
    canExpandRight,
    canExpandBottom,
    canExpandTop,
    canCollapseTop,
    canCollapseLeft,
    canCollapseRight,
    canCollapseBottom,
    createGridAreaDefinition,
};
